export default __webpack_public_path__ + "a22e79e56e27ca93e8b4e996bbb2476a.svg";